<template>
<div class="playlist-wrapper">
    <MainPageHeader/>
    <section class="section">
        <div class="container">
            <div class="columns is-mobile is-centered">
                <div class="column is-half">
                    <div class="content is-small">
                        <h1 class="font-size-big">Form creation</h1>
                    </div>
                    <InputField placeholder="Form name" type="text"/>
                    <TextArea placeholder="Form content"/>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="columns is-mobile is-centered">
                <div class="column is-3">
                    <Button text="Submit" border-color="primary"/>
                </div>
                <div class="column is-3">
                    <Button text="Cancel" border-color="white" @click="goHome"/>
                </div>
            </div>
        </div>
    </section>
</div>
</template>

<script>
import MainPageHeader from '@/components/MainPageHeader.vue';
import InputField from '@/components/input/InputField.vue';
import TextArea from '@/components/input/TextArea.vue';
import Button from '@/components/input/Button.vue';

export default {
    name: 'Form',
    components: {
        Button,
        TextArea,
        InputField,
        MainPageHeader,
    },
    methods: {
        goHome() {
            this.$router.push({
                name: 'mainPage',
            });
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";
@import "@/assets/scss/bulma/projectBulma.scss";

</style>
